import React from "react";
import { FaShieldAlt, FaLock, FaTruck } from "react-icons/fa";

const MerchandisePartners = () => {
   return (
    <>
      <section className="partnerSection">
        <div className="partnerLabelWrap">
          <span></span>
          <p className="partnerLabel">MERCHANDISE PARTNER</p>
          <span></span>
        </div>

        <h2>
          Shop official merchandise <br />
          with our trusted partners
        </h2>

        <p className="partnerIntro">
          Explore official merchandise from our trusted retail partners.
          <br />
          Quality products. Officially licensed.
        </p>

        <div className="partnerGrid">
          <a
            href="https://shop.nzfootball.co.nz/"
            target="_blank"
            rel="noopener noreferrer"
            className="partnerCard"
          >
            <div className="dotPattern"></div>

            <img
              src="/img/logos/nzf-logo.png"
              alt="New Zealand Football"
              className="partnerLogo nzfLogo"
            />

            <div className="blueLine"></div>

            <h3>NZ Football Store</h3>

            <p>
              Official merchandise of New Zealand Football. Rep the Ferns and
              all New Zealand teams.
            </p>

            <span className="visitBtn">VISIT STORE <b>→</b></span>
          </a>

          <a
            href="https://sportsfan.co.nz/"
            target="_blank"
            rel="noopener noreferrer"
            className="partnerCard"
          >
            <div className="dotPattern"></div>

            <img
              src="/img/logos/sportsfan-logo.png"
              alt="SportsFan New Zealand"
              className="partnerLogo sportsfanLogo"
            />

            <div className="blueLine"></div>

            <h3>SportsFan New Zealand</h3>

            <p>
              Your home for officially licensed sports merchandise, apparel and
              collectibles.
            </p>

            <span className="visitBtn">VISIT STORE <b>→</b></span>
          </a>
        </div>

        <div className="partnerBenefits">
          <img src="/img/nz.svg" className="benefitNzMap" alt="" />

          <div className="benefitItem">
            <div className="benefitIcon">
              <FaShieldAlt />
            </div>
            <div>
              <h4>Officially Licensed</h4>
              <p>All products are 100% official and fully licensed.</p>
            </div>
          </div>

          <div className="benefitDivider"></div>

          <div className="benefitItem">
            <div className="benefitIcon">
              <FaLock />
            </div>
            <div>
              <h4>Secure Shopping</h4>
              <p>Your information is protected with industry-leading security.</p>
            </div>
          </div>

          <div className="benefitDivider"></div>

          <div className="benefitItem">
            <div className="benefitIcon">
              <FaTruck />
            </div>
            <div>
              <h4>Fast & Reliable Delivery</h4>
              <p>Quick dispatch and reliable delivery across New Zealand.</p>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .partnerSection {
          width: 100%;
          padding: 90px 24px;
          background: #ffffff;
          text-align: center;
          font-family: Arial, sans-serif;
        }

        .partnerLabelWrap {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 24px;
          margin-bottom: 18px;
        }

        .partnerLabelWrap span {
          width: 110px;
          height: 2px;
          background: #007cff;
        }

        .partnerLabel {
          color: #006eff;
          font-size: 16px;
          font-weight: 900;
          letter-spacing: 6px;
          margin: 0;
        }

        .partnerSection h2 {
          color: #07194a;
          font-size: 64px;
          line-height: 1.08;
          font-weight: 900;
          margin: 0;
        }

        .partnerIntro {
          color: #5a647a;
          font-size: 22px;
          line-height: 1.5;
          margin: 32px auto 60px;
        }

        .partnerGrid {
          max-width: 1320px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 40px;
        }

        .partnerCard {
          position: relative;
          overflow: hidden;
          min-height: 500px;
          padding: 64px 56px 54px;
          border: 1px solid #cfdcf0;
          border-radius: 18px;
          background: #ffffff;
          text-decoration: none;
          color: inherit;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          box-shadow: 0 14px 34px rgba(7, 25, 74, 0.06);
          transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
        }

        .partnerCard::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(0,124,255,0.06), rgba(255,255,255,0));
          opacity: 0;
          transition: opacity 0.35s ease;
          z-index: 1;
        }

        .partnerCard::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 5px;
          background: #007cff;
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.35s ease;
          z-index: 3;
        }

        .partnerCard:hover {
          transform: translateY(-10px);
          border-color: #007cff;
          box-shadow: 0 26px 55px rgba(7, 25, 74, 0.16);
        }

        .partnerCard:hover::before {
          opacity: 1;
        }

        .partnerCard:hover::after {
          transform: scaleX(1);
        }

        .dotPattern {
          position: absolute;
          right: 45px;
          top: 125px;
          width: 120px;
          height: 150px;
          opacity: 0.18;
          background-image: radial-gradient(#007cff 1.5px, transparent 1.5px);
          background-size: 12px 12px;
          transition: transform 0.35s ease, opacity 0.35s ease;
          z-index: 1;
        }

        .partnerCard:hover .dotPattern {
          transform: translate(-8px, 8px);
          opacity: 0.32;
        }

        .partnerLogo {
          max-width: 330px;
          max-height: 110px;
          object-fit: contain;
          margin-bottom: 38px;
          position: relative;
          z-index: 2;
          transition: transform 0.35s ease;
        }

        .partnerCard:hover .partnerLogo {
          transform: scale(1.04);
        }

        .nzfLogo {
          max-width: 260px;
        }

        .sportsfanLogo {
          max-width: 350px;
        }

        .blueLine {
          width: 55px;
          height: 4px;
          background: #007cff;
          border-radius: 50px;
          margin-bottom: 34px;
          position: relative;
          z-index: 2;
          transition: width 0.35s ease;
        }

        .partnerCard:hover .blueLine {
          width: 85px;
        }

        .partnerCard h3 {
          color: #07194a;
          font-size: 36px;
          font-weight: 900;
          margin: 0 0 18px;
          position: relative;
          z-index: 2;
        }

        .partnerCard p {
          max-width: 520px;
          color: #5a647a;
          font-size: 21px;
          line-height: 1.45;
          margin: 0 0 42px;
          position: relative;
          z-index: 2;
        }

        .visitBtn {
          width: 100%;
          max-width: 370px;
          padding: 18px 30px;
          border: 2px solid #007cff;
          border-radius: 8px;
          color: #006eff;
          font-size: 18px;
          font-weight: 900;
          letter-spacing: 1.5px;
          transition: all 0.3s ease;
          position: relative;
          z-index: 2;
        }

        .visitBtn b {
          display: inline-block;
          transition: transform 0.3s ease;
        }

        .partnerCard:hover .visitBtn {
          background: #007cff;
          color: #ffffff;
        }

        .partnerCard:hover .visitBtn b {
          transform: translateX(8px);
        }

        .partnerBenefits {
          position: relative;
          overflow: hidden;
          max-width: 1450px;
          margin: 42px auto 0;
          padding: 38px 55px;
          border-radius: 18px;
          background: linear-gradient(135deg, #061f3d 0%, #082a4d 58%, #005e91 100%);
          display: grid;
          grid-template-columns: 1fr auto 1fr auto 1fr;
          align-items: center;
          gap: 35px;
          box-shadow: 0 18px 40px rgba(7, 25, 74, 0.18);
          text-align: left;
        }

        .benefitNzMap {
          position: absolute;
          right: 40px;
          bottom: -45px;
          width: 190px;
          opacity: 0.12;
          filter: brightness(0) invert(1);
          z-index: 1;
        }

        .benefitItem {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          gap: 22px;
          transition: transform 0.3s ease;
        }

        .benefitItem:hover {
          transform: translateY(-5px);
        }

        .benefitIcon {
          width: 88px;
          height: 88px;
          border-radius: 50%;
          background: #eef5ff;
          border: 2px solid #cfe0ff;
          color: #007cff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 34px;
          flex-shrink: 0;
          box-shadow: 0 8px 20px rgba(0, 110, 255, 0.15);
          transition: all 0.3s ease;
        }

        .benefitItem:hover .benefitIcon {
          background: #007cff;
          color: #ffffff;
          transform: scale(1.08);
        }

        .benefitItem h4 {
          color: #ffffff;
          font-size: 23px;
          line-height: 1.15;
          font-weight: 900;
          margin: 0 0 8px;
        }

        .benefitItem p {
          color: rgba(255,255,255,0.88);
          font-size: 16px;
          line-height: 1.4;
          margin: 0;
          max-width: 280px;
        }

        .benefitDivider {
          position: relative;
          z-index: 2;
          width: 1px;
          height: 78px;
          background: rgba(255,255,255,0.22);
        }

        @media (max-width: 1100px) {
          .partnerSection h2 {
            font-size: 46px;
          }

          .partnerGrid {
            grid-template-columns: 1fr;
          }

          .partnerBenefits {
            grid-template-columns: 1fr;
            gap: 28px;
          }

          .benefitDivider {
            display: none;
          }

          .benefitItem {
            max-width: 520px;
            width: 100%;
            margin: 0 auto;
          }
        }

        @media (max-width: 600px) {
          .partnerSection {
            padding: 65px 16px;
          }

          .partnerLabelWrap span {
            display: none;
          }

          .partnerLabel {
            font-size: 13px;
            letter-spacing: 4px;
          }

          .partnerSection h2 {
            font-size: 34px;
          }

          .partnerIntro {
            font-size: 18px;
            margin-bottom: 42px;
          }

          .partnerCard {
            min-height: auto;
            padding: 45px 25px;
          }

          .partnerLogo {
            max-width: 240px;
          }

          .nzfLogo {
            max-width: 190px;
          }

          .partnerCard h3 {
            font-size: 27px;
          }

          .partnerCard p {
            font-size: 17px;
          }

          .partnerBenefits {
            padding: 32px 24px;
          }

          .benefitItem {
            flex-direction: column;
            text-align: center;
          }

          .benefitIcon {
            width: 72px;
            height: 72px;
            font-size: 28px;
          }

          .benefitItem h4 {
            font-size: 20px;
          }

          .benefitItem p {
            font-size: 15px;
          }
        }
      `}</style>
    </>
  );
};

export default MerchandisePartners;